import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	exportTimelineErrorTitle: {
		id: 'eoc-schedule.controllers.schedule.export-timeline-error-title',
		defaultMessage: "We couldn't export your schedule.",
		description:
			'This message indicates that our back-end services did not respond when exporting schedule.',
	},
	exportTimelineSuccessTitle: {
		id: 'eoc-schedule.controllers.schedule.export-timeline-success-title',
		defaultMessage: 'Your schedule is successfully exported.',
		description: 'This message indicates schedule is successfully exported.',
	},
});
